import actionTypes from './actionTypes';
import { action, generateErrorAction } from '../actions';
import API from '../../apis';

export const fetchAllCafeEvents = query => {
  const request = () => dispatch => {
    dispatch(loading());
    return API.cafeEvents
      .fetchAllCafeEvents(query)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.FETCH_ALL_CAFE_EVENTS_FAILED,
            reject: actionTypes.FETCH_ALL_CAFE_EVENTS_REJECT
          })
        );
        throw err;
      });
  };
  const loading = _ => action(actionTypes.FETCH_ALL_CAFE_EVENTS_LOADING);
  const success = res => action(actionTypes.FETCH_ALL_CAFE_EVENTS_SUCCESS, res);

  return request();
};

export const fetchAllArchivedCafeEvents = query => {
  const request = () => dispatch => {
    dispatch(loading());
    return API.cafeEvents
      .fetchAllArchivedCafeEvents(query)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.FETCH_ALL_ARCHIVED_CAFE_EVENTS_FAILED,
            reject: actionTypes.FETCH_ALL_ARCHIVED_CAFE_EVENTS_REJECT
          })
        );
        throw err;
      });
  };
  const loading = _ => action(actionTypes.FETCH_ALL_ARCHIVED_CAFE_EVENTS_LOADING);
  const success = res => action(actionTypes.FETCH_ALL_ARCHIVED_CAFE_EVENTS_SUCCESS, res);

  return request();
};

export const fetchAllRequestedCafeEvents = query => {
  const request = () => dispatch => {
    dispatch(loading());
    return API.cafeEvents
      .fetchAllRequestedCafeEvents(query)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.FETCH_ALL_REQUESTED_CAFE_EVENTS_FAILED,
            reject: actionTypes.FETCH_ALL_REQUESTED_CAFE_EVENTS_REJECT
          })
        );
        throw err;
      });
  };
  const loading = _ => action(actionTypes.FETCH_ALL_REQUESTED_CAFE_EVENTS_LOADING);
  const success = res => action(actionTypes.FETCH_ALL_REQUESTED_CAFE_EVENTS_SUCCESS, res);

  return request();
};

export const fetchCafeEventDetailsById = id => {
  const request = () => dispatch => {
    dispatch(loading());
    return API.cafeEvents
      .fetchCafeEventDetailsById(id)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.FETCH_CAFE_EVENT_BY_ID_FAILED,
            reject: actionTypes.FETCH_CAFE_EVENT_BY_ID_REJECT
          })
        );
        throw err;
      });
  };
  const loading = _ => action(actionTypes.FETCH_CAFE_EVENT_BY_ID_LOADING);
  const success = res => action(actionTypes.FETCH_CAFE_EVENT_BY_ID_SUCCESS, res);

  return request();
};

export const addCafeEvent = event => {
  const request = () => dispatch => {
    dispatch(loading());
    return API.cafeEvents
      .addCafeEvent(event)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.ADD_CAFE_EVENT_FAILED,
            reject: actionTypes.ADD_CAFE_EVENT_REJECT
          })
        );
        throw err;
      });
  };
  const loading = _ => action(actionTypes.ADD_CAFE_EVENT_LOADING);
  const success = res => action(actionTypes.ADD_CAFE_EVENT_SUCCESS, res);

  return request();
};

export const updateCafeEvent = event => {
  const request = () => dispatch => {
    dispatch(loading());
    return API.cafeEvents
      .updateCafeEvent(event)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.UPDATE_CAFE_EVENT_FAILED,
            reject: actionTypes.UPDATE_CAFE_EVENT_REJECT
          })
        );
        throw err;
      });
  };
  const loading = _ => action(actionTypes.UPDATE_CAFE_EVENT_LOADING);
  const success = res => action(actionTypes.UPDATE_CAFE_EVENT_SUCCESS, res);

  return request();
};

export const confirmEvent = event => {
  const request = () => dispatch => {
    dispatch(loading());
    return API.cafeEvents
      .confirmEvent(event)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.CONFIRM_CAFE_EVENT_FAILED,
            reject: actionTypes.CONFIRM_CAFE_EVENT_REJECT
          })
        );
        throw err;
      });
  };
  const loading = _ => action(actionTypes.CONFIRM_CAFE_EVENT_LOADING);
  const success = res => action(actionTypes.CONFIRM_CAFE_EVENT_SUCCESS, res);

  return request();
};

export const rejectEvent = (id, reason) => {
  const request = () => dispatch => {
    dispatch(loading());
    return API.cafeEvents
      .rejectEvent(id, reason)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.REJECT_CAFE_EVENT_FAILED,
            reject: actionTypes.REJECT_CAFE_EVENT_REJECT
          })
        );
        throw err;
      });
  };
  const loading = _ => action(actionTypes.REJECT_CAFE_EVENT_LOADING);
  const success = res => action(actionTypes.REJECT_CAFE_EVENT_SUCCESS, res);

  return request();
};

export const disableEvent = event => {
  const request = () => dispatch => {
    dispatch(loading());
    return API.cafeEvents
      .disableEvent(event)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.DISABLE_CAFE_EVENT_FAILED,
            reject: actionTypes.DISABLE_CAFE_EVENT_REJECT
          })
        );
        throw err;
      });
  };
  const loading = _ => action(actionTypes.DISABLE_CAFE_EVENT_LOADING);
  const success = res => action(actionTypes.DISABLE_CAFE_EVENT_SUCCESS, res);

  return request();
};

export const clearAddEventForm = () => {
  return action(actionTypes.CLEAR_ADD_EVENT_FORM);
};
